import { render } from "./ItemsOneView.vue?vue&type=template&id=51058ea5&scoped=true"
import script from "./ItemsOneView.vue?vue&type=script&lang=js"
export * from "./ItemsOneView.vue?vue&type=script&lang=js"

import "./ItemsOneView.vue?vue&type=style&index=0&id=51058ea5&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51058ea5"]])

export default __exports__